export default __webpack_public_path__ + "static/media/H0005.de05486a.png";